import { render, staticRenderFns } from "./NavigationButton.vue?vue&type=template&id=0c14d687&scoped=true"
import script from "./NavigationButton.vue?vue&type=script&lang=ts"
export * from "./NavigationButton.vue?vue&type=script&lang=ts"
import style0 from "./NavigationButton.vue?vue&type=style&index=0&id=0c14d687&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c14d687",
  null
  
)

export default component.exports